export default [
    {
        path: '/advertisers-cost',
        name: 'PageAdvertisersCostList',
        meta: { title: 'advertisersCost.listTitle', roles: ['ADMIN'], permissions: ['advertiser_cost_view'] },
        component: () => import('@/pages/advertisers-cost'),
    },
]